<template>
  <div>
    <ReportStatStaticCard
      :points="meta.reports"
      :metrics="metrics"
      :selectedIndex="selectedMetricIndex"
      @onClick="onMetricClick"
    />
    <div class="search_container mt_16">
        <SearchInput
        :placeholder="$t('CAMPAIGN.FILTERS.SEARCH_PLACEHOLDER')"
        v-model="searchValue"
        @search="onSearch"
        />
    </div>

    <section class="filter_bars">
      <div class="filter_bar">
        <p class="input_label">{{$t('ORDER.LIST_TABLE.DATE.LABEL')}}</p>
        <date-range-picker
          :confirm-text="$t('ORDER.LIST_TABLE.DATE_SELECT_CONFIRM_BTN')"
          :placeholder="$t('ORDER.LIST_TABLE.DATE.PLACEHOLDER')"
          class="font_normal order_start_date"
          :value="dateRange"
          @change="handleDateChange"
          :disabledDate="disableFilterDate"
        />
      </div>
      <div class="filter_bar">
        <p class="input_label">{{$t('CAMPAIGN.FILTERS.STATUS')}}</p>
        <multiselect
          v-model="selectedStatus"
          :options="statusList"
          class="small-12 font_normal"
          track-by="id"
          label="title"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="false"
          :hide-selected="true"
          :placeholder="$t('CAMPAIGN.FILTERS.STATUS_PLACEHOLDER')"
          selected-label
          :select-label="''"
          :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
          @select="applyFilterByStatuses($event)"
        />
      </div>
      <!-- <div class="filter_bar">
        <p class="input_label">{{$t('CAMPAIGN.FILTERS.SORT_BY')}}</p>
        <multiselect
          v-model="sortBy"
          :options="sortByList"
          class="small-12 font_normal"
          track-by="id"
          label="title"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="false"
          :hide-selected="true"
          :placeholder="$t('CAMPAIGN.FILTERS.SORTBY_PLACEHOLDER')"
          selected-label
          :select-label="''"
          :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
          @select="applyFilterBySortBy($event)"
        />
      </div> -->

    </section>

    <ContactAppointmentTable
      :cols="cols"
      :isLoading="uiFlags.isFetching"
      :records="records"
      :showEmptyResult="!uiFlags.isFetching && !records.length"
    />
    <div>
        <table-footer
        :on-page-change="onPageChange"
        :current-page="Number(meta.current_page)"
        :total-count="meta.count"
        :pageSize="meta.page_size"
        />
    </div>


  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import helperMixin from 'shared/mixins/helperMixin';
import alertMixin from 'shared/mixins/alertMixin';
import DateRangePicker from "components/ui/DateRangePicker.vue"
import moment from "moment";
import TableFooter from 'dashboard/components/widgets/TableFooter';
import SearchInput from 'dashboard/components/ui/SearchInput.vue'

import ContactAppointmentTable from "./ContactAppointmentTable.vue"
import {APPOINTMENT_BY_CONTACT_STATUS} from "./contact_constant"
import ReportStatStaticCard from "dashboard/routes/dashboard/settings/campaigns/broadcastAgent/ReportStatStaticCard.vue"


export default {
  components:{
    DateRangePicker,
    TableFooter,
    SearchInput,
    ContactAppointmentTable,
    ReportStatStaticCard,
  },
  mixins:[helperMixin,alertMixin],
  props:{
    contactId:{
      type: Number,
      required: true,
    },
  },
  data(){
    const endDate = new Date(); // Current date
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1); // One month ago

    return {
      dateRange: [startDate,endDate],
      searchValue:'',
      selectedStatus: null,
      // sortBy:null,
      // records:[],  // dummy records
      selectedMetricIndex: 999,  // no need active so invalid index
    }
  },
  computed:{
    ...mapGetters({
        currentUser: 'getCurrentUser',
        uiFlags: "meetings/getMeetingsByContactUIFlags",
        meta: "meetings/getMeetingsByContactMeta",
        records: "meetings/getMeetingsByContact",
    }),
    paginationCompute(){
        const totalPages = Math.ceil(this.meta.count / this.meta.page_size);
        const isLastPage = this.meta.current_page >= totalPages;
        const currentCount = Math.min(this.meta.current_page * this.meta.page_size, this.meta.count);
        // const btnText = `Load More Orders (${currentCount}/${this.meta.count})`;
        const btnText = `${this.$t('CAMPAIGN.LLM_CHATBOT.REPORT.LOAD_MORE_BTN')} (${currentCount}/${this.meta.count})`;

        return{
            isLastPage,
            btnText,
        }
    },
    cols(){
      const cols = [
        { key: 'title', name: 'Name', visible: true, type: 'default' },
        { key: 'description', name: 'Description', visible: true, type: 'default' },
        { key: 'friendly_time', name: 'Scheduled', visible: true, type: 'default' },
        { key: 'status', name: 'Status', visible: true, type: 'default' },
        { key: 'location', name: 'Location', visible: true, type: 'default' },
        { key: 'actions', name: 'Actions', visible: true, type: 'default' },
      ]

      return cols;
    },
    statusList(){
      return APPOINTMENT_BY_CONTACT_STATUS.map(el=>({...el,title:this.$t(el.title)}))
    },
    // sortByList(){
    //   // return AI_CAMPAIGN_SORT_LIST.map(el=>({...el,title:this.$t(el.title)}))
    //   return []
    // },
    metrics() {
      // this.meta.reports
      // return CONTACT_APPOINTMENT_METRICS.map(el=>({...el,NAME:this.$t(el.NAME)}));
      return Object.entries(this.meta.reports).map(([key, value]) => ({
        NAME: key.charAt(0).toUpperCase() + key.slice(1),
        KEY: key,
        DESC: '( total )',
      }));
    },
  },
  mounted() {
  // When revisiting the route (with <keep-alive>)
    this.getRecordList({
      page: 1,
      start_date: this.formatStartEndDate(this.dateRange[0],this.dateRange[1]).start_date,
      end_date: this.formatStartEndDate(this.dateRange[0],this.dateRange[1]).end_date,
    });
  },
  methods:{
    async getRecordList(newQuery={}){
      try {
        const defautQuery = {
          page: this.meta.current_page,
          page_size:  this.meta.page_size,
          contact_id:this.contactId,
          q: this.searchValue,
          status: this.selectedStatus?.id,
          // order: this.sortBy?.order,
          // direction: this.sortBy?.direction,
          start_date: this.formatStartEndDate(this.dateRange[0],this.dateRange[1]).start_date,
          end_date: this.formatStartEndDate(this.dateRange[0],this.dateRange[1]).end_date,
          ...newQuery,
        }
        this.$store.dispatch("meetings/getMeetingReportByContact",this.cleanObject(defautQuery));
      } catch (error) {
        console.log(error);
        this.showErrAlert(error,this.$t('CAMPAIGN.NETWORK_ERR.FETCH_ERR'));
      }
    },
    async handleDateChange(dateRange) {
      this.dateRange = dateRange;
      const date = this.formatStartEndDate(dateRange[0],dateRange[1]);
      this.getRecordList({
        page: 1,
        start_date: date.start_date,
        end_date: date.end_date,
      })
    },
    disableFilterDate(date, currentValues) {
      return false; // no disable any date
    },
    onPageChange(page){
      this.getRecordList({page,})
    },
    applyFilterByStatuses(selectedOption){
      this.selectedStatus = selectedOption;
      this.getRecordList({status:selectedOption.id});
    },
    // applyFilterBySortBy(selectedOption){
    //   this.sortBy = selectedOption;
    //   this.getRecordList({
    //       order: selectedOption.order,
    //       direction: selectedOption.direction,
    //   });
    // },
    onSearch(value){
      this.getRecordList({q:value,page:1});
    },
    onMetricClick(index) {
        // this.selectedMetricIndex = index;
        // this.fetchChartData();
    },
    // end
  },

}
</script>

<style scoped lang="scss">
.search_container{
  max-width: 280px;
}
.filter_bars{
  display: flex;
  gap: 12px;
  margin-top: 16px;
  .filter_bar{
    p{
      margin-bottom: 8px;
    }
  }
}

</style>